/** DVA namespace — must match `model.js` and route registration. */
export const MODEL_NAME = 'aiSkillGroups';

/** API route prefix — shared by `model.js` (createCrudModel) and list descriptor routes. */
export const FETCH_ROUTE = 'ai/skillGroup';

/**
 * Singular entity name for `createCrudModel` reducers (`itemActivate`, `bulkItemActivate`).
 * Legacy value — kept to match existing custom bulk effects in `model.js`.
 */
export const ENTITY_NAME = 'item';

/** i18n resource key for form drawer hero summary (`configForm.hero.summary.resource.{key}.*`). */
export const FORM_RESOURCE_KEY = 'aiSkillGroups';
